import React, {useEffect} from 'react';
import clsx from 'clsx';
import isNull from 'lodash/isNull';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import Footer from '../Footer';
import 'jquery.easing';
import Sidebar from '../Sidebar';
import Navbar from '../Navbar';

import useStyles from './styles';
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";

const propTypes = {
    children: PropTypes.any.isRequired,
};

const defaultProps = {
    children: {},
};

function AuthorizedLayout({children}) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const history = useHistory();
    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);
    const {access_token} = useSelector(state => state.auth);
    // const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    useEffect(() => {
        if (isNull(access_token)) {
            history.push(`/login`);
        }
    }, [])

    return (
        <div className={classes.root}>
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
                  rel="stylesheet"/>
            <CssBaseline/>
            <AppBar
                position="absolute"
                className={clsx(classes.appBar, open && classes.appBarShift)}
            >
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(
                            classes.menuButton,
                            open && classes.menuButtonHidden,
                        )}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography
                        component="h1"
                        variant="h6"
                        color="inherit"
                        noWrap
                        className={classes.title}
                    >
                    </Typography>
                    <Navbar/>

                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon/>
                    </IconButton>
                </div>
                <Divider/>
                <Sidebar/>
                <Divider/>
            </Drawer>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                    <Grid
                        container
                        spacing={0}
                        justify="center"
                    >
                        {children}
                    </Grid>
                    <Box pt={4}>
                        <Footer/>
                    </Box>
            </main>
        </div>
    );
}

AuthorizedLayout.propTypes = propTypes;
AuthorizedLayout.defaultProps = defaultProps;
export default AuthorizedLayout;



// WEBPACK FOOTER //
// ./src/template/AuthorizedLayout/index.jsx